import { render } from "./WorkOrderProfile.vue?vue&type=template&id=0b9d032e&scoped=true"
import script from "./WorkOrderProfile.vue?vue&type=script&lang=js"
export * from "./WorkOrderProfile.vue?vue&type=script&lang=js"

import "./WorkOrderProfile.vue?vue&type=style&index=0&id=0b9d032e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b9d032e"]])

export default __exports__